export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14890.f1b8bdfd.jpg";